var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJokerProLucky7Icon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5062 27.832L16.0835 32.8125L14.6607 27.832C14.293 26.5455 13.6036 25.3739 12.6574 24.4278C11.7113 23.4817 10.5397 22.7922 9.25325 22.4245L4.271 21L9.2515 19.5773C10.538 19.2095 11.7096 18.5201 12.6557 17.574C13.6018 16.6278 14.2913 15.4562 14.659 14.1698L16.0835 9.1875L17.5062 14.168C17.874 15.4545 18.5634 16.6261 19.5095 17.5722C20.4557 18.5183 21.6273 19.2078 22.9137 19.5755L27.896 21L22.9155 22.4227C21.629 22.7905 20.4574 23.4799 19.5113 24.426C18.5652 25.3722 17.8757 26.5438 17.508 27.8302L17.5062 27.832ZM32.2867 15.2513L31.8335 17.0625L31.3802 15.2513C31.1208 14.2128 30.584 13.2643 29.8273 12.5073C29.0706 11.7503 28.1224 11.2131 27.084 10.9532L25.271 10.5L27.084 10.0468C28.1224 9.78689 29.0706 9.24973 29.8273 8.4927C30.584 7.73566 31.1208 6.78722 31.3802 5.74875L31.8335 3.9375L32.2867 5.74875C32.5463 6.78744 33.0834 7.73603 33.8404 8.49308C34.5975 9.25013 35.5461 9.78717 36.5847 10.0468L38.396 10.5L36.5847 10.9532C35.5461 11.2128 34.5975 11.7499 33.8404 12.5069C33.0834 13.264 32.5463 14.2126 32.2867 15.2513ZM29.898 35.9922L29.2085 38.0625L28.519 35.9922C28.3257 35.4124 28 34.8854 27.5678 34.4532C27.1356 34.021 26.6086 33.6953 26.0287 33.502L23.9585 32.8125L26.0287 32.123C26.6086 31.9297 27.1356 31.604 27.5678 31.1718C28 30.7396 28.3257 30.2126 28.519 29.6328L29.2085 27.5625L29.898 29.6328C30.0913 30.2126 30.417 30.7396 30.8492 31.1718C31.2814 31.604 31.8083 31.9297 32.3882 32.123L34.4585 32.8125L32.3882 33.502C31.8083 33.6953 31.2814 34.021 30.8492 34.4532C30.417 34.8854 30.0913 35.4124 29.898 35.9922Z",
    stroke: "url(#paint0_linear_6447_27603)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6447_27603",
    x1: 9.92591,
    y1: 17.4545,
    x2: 45.1511,
    y2: 45.2221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJokerProLucky7Icon1);
export default __webpack_public_path__ + "static/media/jokerProLucky7Icon1.c2a076f2401edb859ef7b409c1962c0e.svg";
export { ForwardRef as ReactComponent };